import { render, staticRenderFns } from "./ModalItemsByAtencion.vue?vue&type=template&id=63f29185"
import script from "./ModalItemsByAtencion.vue?vue&type=script&lang=js"
export * from "./ModalItemsByAtencion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports